/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { EventItem } from '../../models/event-item';

export interface EventControllerGetOne$Params {
  monitoringId: number;
  id: number;
}

export function eventControllerGetOne(http: HttpClient, rootUrl: string, params: EventControllerGetOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EventItem;
}>> {
  const rb = new RequestBuilder(rootUrl, eventControllerGetOne.PATH, 'get');
  if (params) {
    rb.path('monitoringId', params.monitoringId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: EventItem;
      }>;
    })
  );
}

eventControllerGetOne.PATH = '/monitoring/{monitoringId}/events/{id}';
